<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :actions="actions"
      :beforeSetupGrid="beforeSetupGrid"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      name="GeoStudentStatus"
      ref="grid"
    ></dx-grid>

    <v-dialog persistent v-model="detailsDialog" max-width="780">
      <v-card class="geo-student-status-details-card">
        <div class="geo-student-status-details-header">
          <div class="geo-student-status-details-header-info">
            <div class="geo-student-status-details-title">
              <v-icon small color="white" class="mr-2">mdi-map-marker-radius</v-icon>
              <span>{{ studentTitle }}</span>
            </div>
            <div class="geo-student-status-details-subtitle">
              <span v-if="clickedRow.familyID">
                Account {{ clickedRow.familyID }}
              </span>
              <span v-if="clickedRow.studentID">
                &middot; Student {{ clickedRow.studentID }}
              </span>
              <span v-if="clickedRow.term"> &middot; {{ clickedRow.term }}</span>
              <span v-if="clickedRow.busAddress1">
                &middot; {{ clickedRow.busAddress1 }}
              </span>
            </div>
          </div>
          <div class="geo-student-status-details-header-actions">
            <v-btn
              v-if="clickedRow.familyID"
              outline
              small
              dark
              class="geo-student-status-account-btn"
              @click="openAccount()"
            >
              <v-icon small class="mr-1">mdi-account</v-icon>
              Open Account
            </v-btn>
            <v-btn
              icon
              dark
              class="geo-student-status-details-close"
              @click="closeDetails()"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <div
          v-if="hasNoStudentStop"
          class="geo-student-status-no-stop"
        >
          No GEO stops for this student
        </div>

        <account-geo-details
          v-if="detailsDialog && dialogAccount"
          :key="dialogKey"
          :account="dialogAccount"
          :geoInfo="dialogGeoInfo"
          :highlightStudentID="clickedRow.studentID"
        ></account-geo-details>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="syncDialog" max-width="440">
      <v-card class="geo-student-status-sync-card">
        <div class="geo-student-status-sync-header">
          <div class="geo-student-status-sync-header-title">
            <v-icon small color="white" class="mr-2">mdi-sync</v-icon>
            Student Stops
          </div>
          <v-btn
            icon
            dark
            class="ma-0"
            :disabled="syncing || exporting"
            @click="closeSync()"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="geo-student-status-sync-body">
          <div
            v-if="syncResult"
            class="geo-student-status-sync-ok mb-2"
          >
            <v-icon small color="#2e7d32" class="mr-1">mdi-check-circle</v-icon>
            {{ syncResult }}
          </div>
          <div
            v-if="syncError"
            class="geo-student-status-sync-error mb-2"
          >
            <v-icon small color="#c62828" class="mr-1">mdi-alert-circle</v-icon>
            {{ syncError }}
          </div>

          <div v-if="syncing || exporting" class="geo-student-status-sync-progress">
            <v-progress-linear
              indeterminate
              color="success"
              height="4"
              class="mb-2"
            ></v-progress-linear>
            <div class="grey--text">
              {{
                exporting
                  ? "Exporting student stops..."
                  : "Syncing student stops..."
              }}
            </div>
          </div>

          <div v-else>
            <button
              type="button"
              class="geo-student-status-action"
              @click="syncNow()"
            >
              <div class="geo-student-status-action-icon">
                <v-icon color="#2e7d32">mdi-cloud-download</v-icon>
              </div>
              <div class="geo-student-status-action-copy">
                <div class="geo-student-status-action-title">Sync from Geo</div>
                <div class="geo-student-status-action-sub">
                  Sync the latest stops from Geo and replace the local table
                </div>
              </div>
              <v-icon color="#9e9e9e">mdi-chevron-right</v-icon>
            </button>

            <button
              type="button"
              class="geo-student-status-action"
              @click="exportCsv()"
            >
              <div class="geo-student-status-action-icon">
                <v-icon color="#2e7d32">mdi-file-delimited</v-icon>
              </div>
              <div class="geo-student-status-action-copy">
                <div class="geo-student-status-action-title">Export CSV</div>
                <div class="geo-student-status-action-sub">
                  Download the current StudentStops table
                </div>
              </div>
              <v-icon color="#9e9e9e">mdi-chevron-right</v-icon>
            </button>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import accountGeoDetails from "../Account/AccountGeoDetails.vue";
import moment from "moment";

export default {
  components: {
    accountGeoDetails,
  },
  data: () => ({
    title: "Geo Student Status",
    url: "",
    actions: [],
    regID: "",
    status: "All",
    detailsDialog: false,
    clickedRow: {},
    dialogAccount: null,
    dialogGeoInfo: {},
    dialogKey: 0,
    syncDialog: false,
    syncing: false,
    exporting: false,
    syncResult: "",
    syncError: "",
    columns: [
      {
        label: "Student ID",
        field: "studentID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Family ID",
        field: "familyID",
        visible: true,
        link: "Account View",
        template: "link-action-cell-template",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew Name",
        field: "hebName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Name Hebrew",
        field: "lastNameH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "English Name",
        field: "engName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Name",
        field: "lastName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Father",
        field: "fatherNameH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Father",
        field: "fatherName",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Building",
        field: "building",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Branch",
        field: "branch",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Class",
        field: "class",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Section",
        field: "section",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Has Route Stop",
        field: "hasRouteStop",
        visible: true,
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Bus Address",
        field: "busAddress1",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Home Phone",
        field: "homePhone",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Cell Phone",
        field: "cellPhone",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address Validated",
        field: "busAddressValidated",
        visible: false,
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Stop Count",
        field: "routeStopCount",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Synced",
        field: "lastSynced",
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Term",
        field: "term",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Email",
        field: "emailAddress",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address",
        field: "address1",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  computed: {
    studentTitle() {
      const row = this.clickedRow || {};
      const english = [row.engName, row.lastName].filter((v) => v).join(" ");

      if (english && row.hebName) {
        return english + " (" + row.hebName + ")";
      }

      return english || row.hebName || row.studentID || "Student Geo Details";
    },
    hasNoStudentStop() {
      const row = this.clickedRow || {};

      if (row.hasRouteStop === true) {
        return false;
      }

      if (row.routeStopCount > 0) {
        return false;
      }

      return true;
    },
  },
  methods: {
    async beforeSetupGrid() {
      this.restoreStatus();
      await this.loadRegID();

      const terms = await this.getTerms();

      this.columns.find((c) => c.field == "familyID").linkAction = (row) => {
        this.toAccount(row);
      };

      this.columns.find((c) => c.field == "hasRouteStop").getTextColor = (
        value
      ) => {
        return value ? "#2e7d32" : "#c62828";
      };

      this.actions.push({
        text: "Sync Now",
        action: this.openSyncDialog,
      });

      this.actions.push({
        text: "Select Status",
        type: "select",
        values: ["All", "Missing Route Stop", "Has Route Stop"],
        value: this.status,
        onSelected: this.onStatusSelected,
      });

      this.actions.push({
        text: "Select Term",
        type: "select",
        values: terms,
        value: this.regID,
        onSelected: this.onTermSelected,
      });

      this.url = this.buildUrl();
    },
    async loadRegID() {
      this.regID = await this.$http.get("api/allStudents/getRegID");
    },
    async getTerms() {
      return await this.$http.get("api/allStudents/getRegTerms");
    },
    restoreStatus() {
      const stored = localStorage.getItem("geoStudentStatus.selectedStatus");
      const values = ["All", "Missing Route Stop", "Has Route Stop"];

      if (stored && values.indexOf(stored) !== -1) {
        this.status = stored;
      }
    },
    saveStatus() {
      if (this.status) {
        localStorage.setItem("geoStudentStatus.selectedStatus", this.status);
      } else {
        localStorage.removeItem("geoStudentStatus.selectedStatus");
      }
    },
    statusParam() {
      if (this.status == "Missing Route Stop") {
        return "missing";
      }

      if (this.status == "Has Route Stop") {
        return "synced";
      }

      return "";
    },
    buildUrl() {
      return (
        "geoStudentStatus?term=" +
        encodeURIComponent(this.regID || "") +
        "&status=" +
        encodeURIComponent(this.statusParam())
      );
    },
    reloadGrid() {
      this.url = this.buildUrl();
      this.$refs.grid.reloadDataSource(this.url);
    },
    onTermSelected(value) {
      this.regID = value;
      this.reloadGrid();
    },
    onStatusSelected(value) {
      this.status = value;
      this.saveStatus();
      this.reloadGrid();
    },
    async onRowClicked(row) {
      this.clickedRow = row || {};
      this.dialogAccount = {
        accountID: row && row.familyID ? String(row.familyID).trim() : "",
      };
      this.dialogGeoInfo = {
        geoOK: !!(row && row.hasRouteStop),
        busAddress1: row && row.busAddress1,
        busAddress2: row && row.busAddress2,
      };
      this.dialogKey += 1;
      this.detailsDialog = true;

      const familyID = this.dialogAccount.accountID;
      if (!familyID) {
        return;
      }

      try {
        const response = await this.$http.get(
          "api/accounts/GetAccoutInfo?accountID=" +
            encodeURIComponent(familyID)
        );

        if (response && response.accountInfo) {
          this.dialogAccount = response.accountInfo;
          this.dialogGeoInfo = {
            geoOK: response.accountInfo.geoOK,
            busAddress1: response.accountInfo.busAddress1,
            busAddress2: response.accountInfo.busAddress2,
          };
        }
      } catch (e) {}
    },
    closeDetails() {
      this.detailsDialog = false;
      this.clickedRow = {};
      this.dialogAccount = null;
      this.dialogGeoInfo = {};
    },
    openAccount() {
      this.toAccount(this.clickedRow);
    },
    toAccount(row) {
      const familyID =
        row && row.familyID ? String(row.familyID).trim() : "";

      if (!familyID) {
        return;
      }

      const route = this.$router.resolve({
        name: "Account View",
        params: {
          id: familyID,
        },
        query: {
          hideNav: "true",
          goToGeoSection: true,
        },
      });

      this.openAccountWindow(route.href);
    },
    openAccountWindow(url) {
      var availW = window.screen.availWidth || 1280;
      var availH = window.screen.availHeight || 800;
      var width = Math.min(1280, Math.max(980, Math.round(availW * 0.7)));
      var height = Math.min(880, Math.max(720, Math.round(availH * 0.78)));
      width = Math.min(width, availW - 40);
      height = Math.min(height, availH - 60);

      var left = Math.round(
        window.screenX + (window.outerWidth - width) / 2
      );
      var top = Math.round(
        window.screenY + Math.max(36, (window.outerHeight - height) / 4)
      );

      var opened = window.open(
        url,
        "utaAccountView",
        "popup=yes,width=" +
          width +
          ",height=" +
          height +
          ",left=" +
          left +
          ",top=" +
          top +
          ",resizable=yes,scrollbars=yes"
      );
      if (opened && opened.focus) {
        opened.focus();
      }
    },
    openSyncDialog() {
      this.syncResult = "";
      this.syncError = "";
      this.syncing = false;
      this.exporting = false;
      this.syncDialog = true;
    },
    closeSync() {
      if (this.syncing || this.exporting) {
        return;
      }

      this.syncDialog = false;
      this.syncResult = "";
      this.syncError = "";
    },
    async exportCsv() {
      this.exporting = true;
      this.syncResult = "";
      this.syncError = "";

      try {
        const response = await this.$http.post(
          "api/studentStop/exportCsv",
          null,
          {
            responseType: "blob",
            timeout: 300000,
          }
        );

        const blob =
          response instanceof Blob
            ? response
            : new Blob([response], { type: "text/csv;charset=utf-8;" });
        const preview = await blob.slice(0, 80).text();
        if (
          preview.indexOf("<!DOCTYPE") !== -1 ||
          preview.toLowerCase().indexOf("<html") !== -1
        ) {
          throw new Error(
            "Export failed. Restart AdminPortal so the export endpoint is loaded."
          );
        }

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download =
          "StudentStops_" + moment().format("YYYYMMDD") + ".csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        this.syncResult = "Student stops CSV downloaded.";
      } catch (e) {
        this.syncError =
          (e && e.message) || "Failed to export student stops.";
      } finally {
        this.exporting = false;
      }
    },
    async syncNow() {
      this.syncing = true;
      this.syncResult = "";
      this.syncError = "";

      try {
        const response = await this.$http.post(
          "api/studentStop/syncNow",
          null,
          { timeout: 300000 }
        );

        const imported = response && response.imported != null ? response.imported : 0;
        this.syncResult =
          "Synced " +
          imported.toLocaleString() +
          " student stops from Geo.";
        this.reloadGrid();
      } catch (e) {
        this.syncError =
          (e && e.message) || "Failed to sync student stops from Geo.";
      } finally {
        this.syncing = false;
      }
    },
  },
};
</script>
<style>
.geo-student-status-details-card {
  overflow: hidden;
}
.geo-student-status-details-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  background-color: #4caf50;
  color: #fff;
  padding: 12px 16px;
}
.geo-student-status-details-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 500;
}
.geo-student-status-details-subtitle {
  margin-top: 4px;
  font-size: 13px;
  opacity: 0.9;
}
.geo-student-status-details-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.geo-student-status-account-btn {
  border-color: rgba(255, 255, 255, 0.7) !important;
  color: #fff !important;
}
.geo-student-status-details-close {
  margin: 0;
}
.geo-student-status-sync-card {
  overflow: hidden;
}
.geo-student-status-sync-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #4caf50;
  color: #fff;
  padding: 8px 8px 8px 16px;
}
.geo-student-status-sync-header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
}
.geo-student-status-sync-body {
  padding: 12px;
}
.geo-student-status-action {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  background: #f7faf7;
  border: 1px solid #c8e6c9;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;
  cursor: pointer;
}
.geo-student-status-action:last-child {
  margin-bottom: 0;
}
.geo-student-status-action:hover {
  background: #e8f5e9;
  border-color: #81c784;
}
.geo-student-status-action-icon {
  width: 36px;
  height: 36px;
  border-radius: 18px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}
.geo-student-status-action-copy {
  flex: 1;
  min-width: 0;
}
.geo-student-status-action-title {
  font-weight: 500;
  color: #2e7d32;
  font-size: 14px;
  line-height: 1.3;
}
.geo-student-status-action-sub {
  color: #757575;
  font-size: 12px;
  line-height: 1.35;
  margin-top: 2px;
}
.geo-student-status-sync-progress {
  padding: 4px 0;
}
.geo-student-status-sync-ok,
.geo-student-status-sync-error {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 10px;
  border-radius: 6px;
}
.geo-student-status-sync-ok {
  color: #2e7d32;
  background-color: #e8f5e9;
}
.geo-student-status-sync-error {
  color: #c62828;
  background-color: #ffebee;
}
.geo-student-status-no-stop {
  color: #c62828;
  background-color: #ffebee;
  font-weight: 500;
  font-size: 13px;
  padding: 8px 16px;
}
</style>
